import { Product } from "@/data/data";
import Checkbox from "shared/Checkbox/Checkbox";
import { Disclosure } from "@headlessui/react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
interface ModifierSetsContentProps {
  itemData: Product[];
  modifierCheckedDatastate: any;
  checkedItem: any;
  showError: any;
  setModifierCheckedDatastate: any;
}

function ModifierSetsContent({
  itemData,
  modifierCheckedDatastate,
  checkedItem,
  showError,
  setModifierCheckedDatastate,
}: ModifierSetsContentProps) {
  const location = useLocation();
  const handleCheckboxChange = (
    checked: boolean,
    id: number,
    item: any,
    nameid: number
  ) => {
    setModifierCheckedDatastate((prev: any) => {
      const updatedState = { ...prev };
      if (!updatedState[nameid]) {
        updatedState[nameid] = {};
      }
      updatedState[nameid][id] = checked;
      if (!checked) {
        delete updatedState[nameid][id];
      }
      return updatedState;
    });
  };
  return (
    <>
      {itemData.map((item, index) => (
        <div key={index} className="w-full rounded-2xl space-y-2.5">
          {item?.modifierSets?.map((modifier, index) => {
            const modifierState =
              modifierCheckedDatastate?.[modifier?.id] || {};
            const selectedCount =
              Object.values(modifierState).filter(Boolean).length;
            const isRequiredError = selectedCount < modifier.noOfRequired;
            const isMaximumError =
              modifier.maximum && selectedCount > modifier.maximum;
            const defaultOpenPanel =
              location.state?.modifierChecked &&
              Object.keys(location.state.modifierChecked).some(
                (ele) =>
                  Number(ele) === modifier.id &&
                  Object.values(location.state.modifierChecked[ele]).some(
                    (mark) => mark === true
                  )
              );
            return (
              <Disclosure key={index} defaultOpen={defaultOpenPanel}>
                {({ open }) => (
                  <>
                    <Disclosure.Button className="flex items-center justify-between w-full px-4 py-2 font-medium text-right bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
                      <span>
                        {modifier.name}{" "}
                        {modifier.noOfRequired > 0 && (
                          <span className="text-sm font-normal ml-auto">
                            (required {modifier.noOfRequired})
                          </span>
                        )}
                        {modifier.noOfRequired === 0 && (
                          <span className="text-sm font-normal ml-auto">
                            (optional)
                          </span>
                        )}
                      </span>

                      {modifier.noOfRequired > 0 && (
                        <span className="text-sm font-normal ml-auto">
                          {" "}
                          upto {modifier.maximum}{" "}
                        </span>
                      )}
                      {modifier.noOfRequired === 0 && (
                        <span className="text-sm font-normal ml-auto">
                          optional, upto {modifier.maximum}
                        </span>
                      )}
                      {/* <span className="text-sm">upto {modifier.maximum}</span> */}
                      {!open ? (
                        <FaAngleDown className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                      ) : (
                        <FaAngleUp className="w-4 h-4 tezxt-slate-600 dark:text-slate-400" />
                      )}
                    </Disclosure.Button>
                    {showError && (
                      <>
                        {isRequiredError && (
                          <p className="text-red-500">
                            Please select at least {modifier.noOfRequired}{" "}
                            modifier{modifier.noOfRequired > 1 ? "s" : ""}.
                          </p>
                        )}
                        {isMaximumError && (
                          <p className="text-red-500">
                            Please select at most {modifier.maximum} modifiers.
                          </p>
                        )}
                      </>
                    )}
                    {/* {modifier?.modifierSetModifierItems?.map(
                      (modifierCheck, index) => (
                        <Disclosure.Panel
                          key={index}
                          className="p-4 pt-3 last:pb-0 text-slate-600 text-sm dark:text-slate-300 leading-6 flex items-center justify-between"
                          as="div"
                        >
                          <label
                            className="flex items-center justify-between w-full cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleCheckboxChange(
                                !modifierCheckedDatastate[modifier.id]?.[
                                  modifierCheck.id
                                ],
                                modifierCheck.id as number,
                                modifierCheck.modifierItem?.name as string,
                                modifier.id
                              );
                            }}
                          >
                            <div className="flex items-center">
                              <Checkbox
                                key={modifierCheck.id}
                                sizeClassName="w-5 h-5"
                                labelClassName="text-sm font-normal"
                                label={modifierCheck.modifierItem?.name}
                                name={modifierCheck.id}
                                onChange={(e) => {
                                  handleCheckboxChange(
                                    e,
                                    modifierCheck.id as number,
                                    modifierCheck.modifierItem?.name as string,
                                    modifier.id
                                  );
                                }}
                                defaultChecked={
                                  checkedItem[modifierCheck.id as number]
                                    ? true
                                    : false
                                }
                                checked={
                                  !!modifierCheckedDatastate[modifier.id]?.[
                                    modifierCheck.id
                                  ]
                                }
                              />
                            </div>
                            <span>
                              ${modifierCheck.modifierItem?.onlinePrice}
                            </span>
                          </label>
                        </Disclosure.Panel>
                      )
                    )} */}
                    {modifier?.modifierSetModifierItems
  ?.slice()
  .sort(
    (a, b) => (a?.orderBy ?? 0) - (b?.orderBy ?? 0) // sort by orderBy ascending
  )
  .map((modifierCheck, index) => (
    <Disclosure.Panel
      key={index}
      className="p-4 pt-3 last:pb-0 text-slate-600 text-sm dark:text-slate-300 leading-6 flex items-center justify-between"
      as="div"
    >
      <label
        className="flex items-center justify-between w-full cursor-pointer"
        onClick={(e) => {
          e.preventDefault();
          handleCheckboxChange(
            !modifierCheckedDatastate[modifier.id]?.[modifierCheck.id],
            modifierCheck.id as number,
            modifierCheck.modifierItem?.name as string,
            modifier.id
          );
        }}
      >
        <div className="flex items-center">
          <Checkbox
            key={modifierCheck.id}
            sizeClassName="w-5 h-5"
            labelClassName="text-sm font-normal"
            label={modifierCheck.modifierItem?.name}
            name={modifierCheck.id}
            onChange={(e) => {
              handleCheckboxChange(
                e,
                modifierCheck.id as number,
                modifierCheck.modifierItem?.name as string,
                modifier.id
              );
            }}
            defaultChecked={
              checkedItem[modifierCheck.id as number] ? true : false
            }
            checked={!!modifierCheckedDatastate[modifier.id]?.[modifierCheck.id]}
          />
        </div>
        <span>${modifierCheck.modifierItem?.onlinePrice}</span>
      </label>
    </Disclosure.Panel>
))}

                  </>
                )}
              </Disclosure>
            );
          })}
        </div>
      ))}
    </>
  );
}

export default ModifierSetsContent;
